var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlimitedConsults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.06379 0.829065C3.34812 0.545146 3.68953 0.324899 4.06541 0.182919C4.44128 0.0409389 4.84304 -0.0195318 5.24405 0.00551423C5.64506 0.0305602 6.03618 0.140551 6.39147 0.328197C6.74676 0.515844 7.05812 0.776861 7.30491 1.09395L10.2217 4.84137C10.7563 5.52878 10.9448 6.4242 10.7336 7.26924L9.84471 10.8281C9.79875 11.0125 9.80123 11.2056 9.85191 11.3887C9.90259 11.5717 9.99975 11.7386 10.1339 11.8731L14.1264 15.8659C14.2611 16.0004 14.4282 16.0977 14.6116 16.1484C14.795 16.1991 14.9884 16.2014 15.1729 16.1551L18.7299 15.2662C19.1469 15.162 19.5821 15.1539 20.0027 15.2425C20.4233 15.3312 20.8182 15.5144 21.1576 15.7781L24.9047 18.6935C26.2518 19.7417 26.3753 21.7324 25.1696 22.9366L23.4894 24.6169C22.2869 25.8195 20.4897 26.3476 18.8144 25.7577C14.5265 24.2489 10.6333 21.7939 7.42353 18.5749C4.20498 15.3654 1.7502 11.4724 0.241258 7.18473C-0.346974 5.5109 0.181135 3.71195 1.3836 2.50939L3.06379 0.829065Z",
    fill: "url(#paint0_linear_2002_1351)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2002_1351",
    x1: -0.606414,
    y1: 0.0000156028,
    x2: 27.9944,
    y2: 0.710832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0279144,
    stopColor: "#A451D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948784,
    stopColor: "#603DB1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlimitedConsults);
export default __webpack_public_path__ + "static/media/unlimited-consults.b1a5d5aebce3f7e6a0ab841ee6f22c0b.svg";
export { ForwardRef as ReactComponent };